var angular = require('angular');
var Promise = require('bluebird');
var ApplicationAPI = require('../../../common/api').Application;

 angular
  .module("app.directives")
  .directive('notes', function (ngDialog) {
    return {
      restrict: 'E',
      scope: {
        type: '@',
        organisationId: '=',
        applicationId: '='
      },
      template: require('./template.pug'),
      replace: true,
      link: function (scope, element, attrs) {
        scope.items = [];

        scope.init = function () {
          ApplicationAPI.GetApplicationNotes(scope.applicationId, scope.type, scope.organisationId).then(function (result) {
            scope.items = result;
          });
        }

        // SAVE & CREATE
        scope.save = function (item) {
          if (item.id) {
            ApplicationAPI.UpdateApplicationNote(scope.applicationId, { noteId: item.id, text: item.text }).then(function () {
              scope.editing = null;
              scope.saving = false;
              scope.init()
            })
          } else {
            ApplicationAPI.CreateApplicationNote(scope.applicationId, { organisationId: scope.organisationId, type: scope.type, text: item.text }).then(function () {
              scope.editing = null;
              scope.saving = false;
              scope.init()
            })
          }
        }

        // DELETE note
        scope.delete = function (item) {
          ApplicationAPI.RemoveApplicationNote(scope.applicationId, item.id).then(function () {
            scope.editing = null;
            scope.saving = false;
            scope.init()
          })
        }


        scope.edit = function (item) {
          scope.cache = angular.copy(item);
          scope.editing = item;
        }

        scope.cancel = function (item) {
          var i = scope.items.indexOf(item);
          scope.editing = null;
          if (!item.id) {
            scope.items.splice(i, 1);
            return;
          }
          scope.items[i] = scope.cache;
        }

        scope.add = function () {
          var i = scope.items.push({ text: '' });
          scope.edit(scope.items[i - 1]);
        }

      scope.init();
      }
    }
  })
